export default {"src":"/_next/static/media/tz.fea9daed.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};